import { useEffect, useState } from 'react'

interface Token { tokenName: string; symbol: string; contractAddress: string; createdAt: string }

export default function LiveFeed() {
  const [tokens, setTokens] = useState<Token[]>([])

  useEffect(() => {
    const fetch_ = () => {
      fetch('/api/tokens/recent')
        .then(r => r.json())
        .then(d => setTokens(d.tokens || []))
        .catch(() => {})
    }
    fetch_()
    const interval = setInterval(fetch_, 15000)
    return () => clearInterval(interval)
  }, [])

  if (!tokens.length) return null

  return (
    <div style={{
      background: 'rgba(124,58,237,0.08)', borderTop: '1px solid rgba(124,58,237,0.2)',
      borderBottom: '1px solid rgba(124,58,237,0.2)', padding: '12px 0', overflow: 'hidden'
    }}>
      <div style={{ display: 'flex', gap: '40px', animation: 'marquee 20s linear infinite', whiteSpace: 'nowrap' }}>
        {[...tokens, ...tokens].map((t, i) => (
          <span key={i} style={{ fontSize: '13px', color: '#a78bfa', flexShrink: 0 }}>
            🟢 <strong>{t.tokenName}</strong> ({t.symbol}) just deployed!
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  )
}
